// extracted by mini-css-extract-plugin
module.exports =  {"fullscreen-video":"FullScreenVideo-wMkv__fullscreen-video","video-holder":"FullScreenVideo-caFd__video-holder","video":"FullScreenVideo-GyRx__video"};